import { CSSProperties, ReactNode, useEffect, useRef } from 'react';
import { detectKeyPress } from '~/utils/utils';

interface IClickOutsideProps {
  children: ReactNode;
  onClose?: (event: MouseEvent | KeyboardEvent) => void;
  style?: CSSProperties;
  className?: string;
  disableClickHandler?: boolean;
  onClick?: any;
}

const ClickOutside = ({
  children,
  style = {},
  onClose,
  onClick,
  className = '',
  disableClickHandler = false,
}: IClickOutsideProps) => {
  const outsideClickRef = useRef<HTMLDivElement>(null);

  const handleClickEvent = (event: MouseEvent) => {
    if (!outsideClickRef.current?.contains(event.target as Node | null)) {
      onClose?.(event);
    }
  };

  function handleKeyEvent(event: KeyboardEvent) {
    if (detectKeyPress(event).escape) {
      onClose?.(event);
    }
  }

  useEffect(() => {
    if (!disableClickHandler) {
      setTimeout(() => {
        document.addEventListener('click', handleClickEvent);
      }, 0);
    }
    document.addEventListener('keydown', handleKeyEvent, true);

    return () => {
      if (!disableClickHandler) {
        setTimeout(() => {
          document.removeEventListener('click', handleClickEvent);
        }, 0);
      }
      document.removeEventListener('keydown', handleKeyEvent, true);
    };
  }, []);

  return (
    <div
      role="presentation"
      className={`click-outside-div ${className}`}
      onClick={onClick}
      style={style}
      ref={outsideClickRef}
    >
      {children}
    </div>
  );
};

export default ClickOutside;
